import { connect_device, exploit_gabb, get_autoconnect, godo, monitor_usb, pair_device, select_existing, send_to_device, set_autoconnect, disconnect, install_app } from "./common"

document.getElementById("pair").addEventListener("click", async () => {
  await pair_device();
});

document.getElementById("start").addEventListener("click", async () => {
  await connect_device();
});

document.getElementById("disconnect").addEventListener("click", async () => {
  await disconnect();
});

document.querySelector("#test_cmd").addEventListener("click", async () => {
  const command_output = (await godo("ls /", true));
  console.log(command_output)
  console.log(command_output.stderr)
  console.log(command_output.stdout)
});

document.querySelector("#exploit").addEventListener("click", async () => {
  await exploit_gabb();
});

document.querySelector("#install").addEventListener("click", async () => {
  const file_input = document.querySelector("#apk");
  const file = file_input.files[0];
  const user_select = document.querySelector("#users");
  install_app(file, user_select.value);
});

document.querySelector("#send").addEventListener("click", async () => {
  const file = document.querySelector("#sender").files[0];
  send_to_device(file);
})

document.querySelector("#run").addEventListener("click", async () => {
  const runner = document.querySelector("#runner");
  await godo(runner.value);
  runner.value = "";
  runner.focus();
});

const device_list = document.querySelector("#devices");
device_list.addEventListener("change", () => {
  select_existing(device_list.value);
});

const autoconnect = document.querySelector("[name=\"autoconnect\"]");
autoconnect.checked = get_autoconnect();
autoconnect.addEventListener("change", () => {
  set_autoconnect(autoconnect.checked);
});

document.querySelector("#startshizuku").addEventListener("click", () => {
  godo(`sh /sdcard/Android/data/moe.shizuku.privileged.api/start.sh`);
})

monitor_usb(device_list);